/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect,useRef } from 'react';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/login.scss'
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import { languages } from '../../utils/languages';
import {passwordResetError} from '../../utils/configs';
import { capitalizeFirstLetter ,fetchUserPermissions, fetchCulture,storageUtil,parseJwtToken} from '../../utils/commonFunctions';
import { themesList, setTheme, DEFAULT_THEME_INDEX } from '../../utils/themes';
import PasswordValidator from '../../common/PasswordValidation';
import UserSession from '../../utils/userSessionClass';
import francelang from '../../assets/france.svg';
import spainlang from '../../assets/spainlang.svg';
import uaelang from '../../assets/uaelang.svg';
import { EmployeeEndpoint, UserEndpoint} from "../../utils/axios";
import { Footer } from '../../common';
import LoadingGIF from '../../assets/loadingIn.gif';
import { FaEye, FaEyeSlash } from "react-icons/fa";

/**
 * Icons
 */
import logo from '../../assets/logo.svg';
import themeSvg from '../../assets/icons/svg/theme-icon.svg';
import enlang from '../../assets/enlang.svg';
import { ForgotPasswordModal } from '../../common/ForgotPasswordModal';

export default function Login() {
  const { t ,ready} = useTranslation();
  const navigate = useNavigate()
  const userSession = new UserSession();

  const [themeClassObj, setThemeClassObj] = React.useState(themesList[DEFAULT_THEME_INDEX]);
  const [username, setUsername] = useState('')
  const [domain, setDomain] = useState(process.env.REACT_APP_ACCOUNT_DOMAIN)
  const [loginMessage, setLoginMessage] = useState({text:""})
  const [password, setPassword] = useState('')
  const [passwordResetPrompt,setPasswordResetPrompt]=useState("");
  const [updatePassword,setUpdatePassword]=useState({currentPassword:"",newPassword:"",confirmPassword:""});
  const [validatePasswordUpdate,setValidatePasswordUpdate]=useState(true);
  const [passwordMatch,setPasswordMatch]=useState(false);
  const [showPass, setshowPass] = useState({ default: false, currentPassword: false, newPassword: false, confirmPassword: false });
  const [adminLogin, setAdminLogin] = useState(false)
  const [isLoggingIn, setisLoggingIn] = useState(false);
  const [ forgotPwdFormData, setShowForgotPwdForm ] = useState({show: false, username: ''});
  const clearMsgTimer = useRef(null);

  React.useEffect(() => {
    /**
     * Set title
     */
    document.title = t(`company.productName`) + ' ' + t(`pages.login`);

  }, [t,ready]);

   React.useEffect(() => {
      setLoginMessage({text:""});
      setPasswordResetPrompt("");
      setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
  }, [username,domain,password,adminLogin]);

    React.useEffect(() => {
  setshowPass(false);
  }, [adminLogin]);

  React.useEffect(() => {
    setLoginMessage({text:''});
}, [updatePassword]);

  async function fetchTieZone() {
    try {
      const res = await fetchCulture();
      if(res.timezone){
        localStorage.setItem("NGO_CULTURE",JSON.stringify(res))
      }
    } catch (error) {
      console.log(error)
    }
  }

  // React.useEffect(() => {
  //  if(username){
  //   authorizer.setPermission(permissions[username]);
  //  }
  // }, [username]);// eslint-disable-line react-hooks/exhaustive-deps


  const currentLanguageCode = i18next.language || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t])

  // // Set a Cookie
  // let setCookie = (cName, cValue, expDays) => {
  //   let date = new Date()
  //   date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000)
  //   const expires = 'expires=' + date.toUTCString()
  //   document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/'
  // }

  // let getCookie = name => {
  //   if (!document.cookie) {
  //     return null
  //   }

  //   const xsrfCookies = document.cookie
  //     .split(';')
  //     .map(c => c.trim())
  //     .filter(c => c.startsWith(name + '='))

  //   if (xsrfCookies.length === 0) {
  //     return null
  //   }
  //   return decodeURIComponent(xsrfCookies[0].split('=')[1])
  // }

  // if (themeLoading === 'loading') {
  //   return (
  //     <div>Loading styles...</div>
  //   );
  // }
 function resetMessages(tOut=3500,type=false){
  if(clearMsgTimer.current){
    clearTimeout(clearMsgTimer.current);
  }
  clearMsgTimer.current= setTimeout(()=>{
setLoginMessage({text:''})
if(type){
  setPasswordResetPrompt("");
  setPassword("");
  setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
}
  },tOut)
  return clearMsgTimer.current;
}


  React.useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t]);

  React.useEffect(() => {
    let theme = themeClassObj;
    if (localStorage.getItem('theme') && typeof localStorage.getItem('theme') === 'object') {
      theme = JSON.parse(localStorage.getItem('theme'));
    }

    setUserTheme(theme);
  }, [themeClassObj]);

  const setUserTheme = (theme = themesList[0]) => {
    setThemeClassObj(theme);
    setTheme(theme);
  };

  const setPermissions=(perArr,userType,userName)=>{
    const permissions = {};
    perArr.forEach(item => {
        const { resource, action } = item;
        if (!permissions[`${userType}-role`]) {
            permissions[`${userType}-role`] = {
                "role": [userName, `${userType}-role`],
            };
        }
        if (permissions[`${userType}-role`][action]) {
            permissions[`${userType}-role`][action].push(resource);
        } else {
            permissions[`${userType}-role`][action] = [resource];
        }
    });
  if(permissions){
    localStorage.setItem('userPermissions', JSON.stringify(permissions));
    localStorage.setItem('userRole', `${userType}-role`);
  }
  }

  const LoginButton = ({
    disabled,
    onClick,
    isLoading,
    buttonText,
    loadingImageSrc,
    className = 'margTop24 sign-in large-button-text-medium',
    ariaLabel = 'Loading',
  }) => {
    return (
      <button
        disabled={disabled}
        className={className}
        onClick={onClick}
      >
        {!isLoading ? (
          <>{buttonText}</>
        ) : (
          <div role="status" aria-live="polite">
            <img
              src={loadingImageSrc}
              className="margBtm16 icon-size-login"
              alt={ariaLabel}
            />
          </div>
        )}
      </button>
    );
  };


const onLoginPress = async (mode) => {
  setisLoggingIn(true);
  setLoginMessage({text:""});
  const isAdmin = adminLogin;
  let axObj;
  let body={};
  if(mode==='login'){
  axObj = UserEndpoint.setHost();
  body = isAdmin
    ? { admin: true, username, password }
    : { clientName: domain, employee: true, username, password };
  storageUtil.set('domain',domain,'local');
  localStorage.setItem('sType', username);

  try {
    const userResp = await axObj.postWithFullResp('idpLogin', body);
    const { data, headers } = userResp || {};
    if (!data || !headers) throw new Error("Invalid response");

    localStorage.setItem('login_credentials', JSON.stringify({ data, headers }));
    localStorage.setItem('token', headers['x-csrf-token']);

    const tokenResp = await parseJwtToken(data);

    if (!tokenResp) throw new Error("Empty token");

    const user = data;
    const userType = tokenResp.userType ?? undefined;
    const userName = tokenResp.userName ?? undefined;
    const userId = tokenResp.userId ?? undefined;
    const employeeId = tokenResp.identity ? tokenResp.identity:userType==='admin'?userId:userName;
    storageUtil.set('employeeId',employeeId,'local');
    const roleName = `${userType}-role`;
    const permissionsResp = await fetchUserPermissions({ ...userResp, ...tokenResp }, { subject: userName, roleName });

    if (permissionsResp?.items?.length) {
      setPermissions(permissionsResp.items, userType, userName);
    }

    const themeToApply = themesList.find(t => t.keyname === user.theme?.keyname) || themesList[0];
    setUserTheme(themeToApply);
    user.theme = themeToApply;

    fetchTieZone();

    userSession.setSession({ ...user, ...tokenResp });

    navigate('/');
  } catch (error) {
    console.error('Login error:', error);
    let erMsg = 'Login Error!';
    try {
      let parsedError = JSON.parse(error.message);
      setPasswordResetPrompt(parsedError.data?.code??"");
      erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
    } catch (_) {}
    setLoginMessage({error:erMsg});
  } finally {
    resetMessages(3500,false);
    setisLoggingIn(false);
  }
}else{
  axObj = EmployeeEndpoint.setHost();
  body ={
    username,
    clientName:domain,
    currentPassword: updatePassword.currentPassword,
    newPassword:  updatePassword.newPassword,
    confirmPassword: updatePassword.confirmPassword,
    isValidPassword: true
};

  try {
    const userResp = await axObj.postWithFullResp('updatePassword', body);
    if(userResp?.status===200){
      const msg = userResp.data?.msg || userResp.data?.message || "Password updated successfully. Please login with new password.";
      setLoginMessage({text:msg});
      resetMessages(2500,true);
    }
  } catch (error) {
    console.error('Login error:', error);
    let erMsg = 'Update Password Error!';
    try {
      let parsedError = JSON.parse(error.message);
      erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
    } catch (_) {}
    setLoginMessage({error:erMsg});
    resetMessages(3500,false);
  } finally {
    setisLoggingIn(false);
  }
}

};


  const showLanguageIcon = (code) => {
    switch (code) {
      case "en":
        return <img className="icon-lang" alt='enlang' src={enlang} />
      case "fr":
        return <img className="icon-lang" alt='france' src={francelang} />
      case "sp":
        return <img className="icon-lang" alt='spainlang' src={spainlang} />
      case "ar":
        return <img className="icon-lang" alt='uaelang' src={uaelang} />
      default:
        return null
    }
  }

const signInFields=()=>{
return(<>
{
  passwordResetPrompt!==passwordResetError?<>
              <div className='h1 lato'>{t('pages.loginContent.welcome-back')}</div>
          <div className='h4 lato margTop16'>
            {t('pages.loginContent.welcomebackMessage')}
          </div>
         <div className='h4 margTop16'>{t('pages.loginContent.accountName')}</div>
          <input
             onChange={e => {
              setDomain(e.target.value)
            }}
            value={domain}
            type='text'
            className='input-field-email'
          />
  <div className='h4 margTop16'>{t('pages.loginContent.userId')}</div>
          <input
          onChange={e => {
            setUsername(e.target.value)
          }}
          value={username}
            type='text'
            className='input-field-email'
          />
          <div className='h4 margTop16'>{t('pages.loginContent.password')}</div>
             <div style={{position:"relative"}}>
              <input
                onChange={e => setPassword(e.target.value)}
                type={showPass ? "text":"password"}
                value={password}
                className='input-field'
              />
              <button onClick={()=>togglePassVisibility("")} style={{position:"absolute",top:"12px",right:"30px"}}>
                {!showPass ? <FaEyeSlash style={{color:"#8c918d"}} size={22}/>:<FaEye  style={{color:"#8c918d"}} size={22}/>}
              </button>
             </div>
  </>
:<>
<div className='flexRow alignItemsCenter textAlignLeft sector-origin-m'>{t('pages.loginContent.passwordUpdateWarning')}</div>
          {Object.keys(updatePassword).length>0?<PasswordValidator passwordMatchError={setPasswordMatch} showValidation={validatePasswordUpdate} empPassword={false} isValidPassword={setValidatePasswordUpdate} passwordFields={updatePassword}/>:null}
          <div className='h4 margTop16'>{t('pages.loginContent.currentPassword')}</div>
             <div style={{position:"relative"}}>
              <input
                onChange={e => setUpdatePassword((_)=>({..._,currentPassword:e.target.value}))}
                type={showPass.currentPassword ? "text":"password"}
                value={updatePassword.currentPassword}
                className='input-field'
              />
              <button onClick={()=>togglePassVisibility('currentPassword')} style={{position:"absolute",top:"12px",right:"30px"}}>
                {!showPass.currentPassword ? <FaEyeSlash style={{color:"#8c918d"}} size={22}/>:<FaEye  style={{color:"#8c918d"}} size={22}/>}
              </button>
             </div>

             <div className='h4 margTop16'>{t('pages.loginContent.newPassword')}</div>
             <div style={{position:"relative"}}>
              <input
                onChange={e => setUpdatePassword((_)=>({..._,newPassword:e.target.value}))}
                type={showPass.newPassword ? "text":"password"}
                value={updatePassword.newPassword}
                className='input-field'
              />
              {passwordMatch?<h6 className="small-body-text-regular-label-upload text-danger">{t('warningTexts.passwordMatchUpdate')}</h6>:<></>}
              <button onClick={()=>togglePassVisibility('newPassword')} style={{position:"absolute",top:"12px",right:"30px"}}>
                {!showPass.newPassword ? <FaEyeSlash style={{color:"#8c918d"}} size={22}/>:<FaEye  style={{color:"#8c918d"}} size={22}/>}
              </button>
             </div>

             <div className='h4 margTop16'>{t('pages.loginContent.confirmPassword')}</div>
             <div style={{position:"relative"}}>
              <input
                onChange={e => setUpdatePassword((_)=>({..._,confirmPassword:e.target.value}))}
                type={showPass.confirmPassword ? "text":"password"}
                value={updatePassword.confirmPassword}
                className='input-field'
              />
              {passwordMatch?<h6 className="small-body-text-regular-label-upload text-danger">{t('warningTexts.passwordMatchUpdate')}</h6>:<></>}
              <button onClick={()=>togglePassVisibility('confirmPassword')} style={{position:"absolute",top:"12px",right:"30px"}}>
                {!showPass.confirmPassword ? <FaEyeSlash style={{color:"#8c918d"}} size={22}/>:<FaEye  style={{color:"#8c918d"}} size={22}/>}
              </button>
             </div>

</>}
</>)
}

  const handleForgotPassword = (e) => {
    setShowForgotPwdForm({ show: true, username: username,loginMode:adminLogin });
  }
  const handleClearForgotPwd = (e) => {
    setShowForgotPwdForm({ show: false, username: '' });
  }

  const togglePassVisibility = (multiInput = "") => {
    if (!multiInput.length) {
      toggleBooleanPassVisibility();
    } else {
      toggleObjectPassVisibility(multiInput);
    }
  }

  const toggleBooleanPassVisibility = () => {
    setshowPass(!showPass);
  }

  const toggleObjectPassVisibility = (multiInput) => {
    setshowPass((prevState) => ({
      ...prevState,
      [multiInput]: !prevState[multiInput] ?? false,
    }));
  }
  return (
    <>
       <ForgotPasswordModal data={forgotPwdFormData} clearForgotPwd={(e) => handleClearForgotPwd(e) } />
    <div className='flexRow'>
      <div className='login-bg height100 width50 flexRow justifyContentCenter alignItemsCenter'>
        <div className='width80 center margBot160'>
          <div><img alt='logo' src={logo} /></div>
        </div>
        <Footer mode={"opened"}/>
      </div>
      <div className='height100 width50 flexRow justifyContentCenter alignItemsCenter right-block'>
        <div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter'>
            <div className="dropdown dropdown-style1">
            <button
              className='btn btn-link dropdown-toggle'
              type="button"
              title={t('pages.loginContent.select-theme')}
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
               <img src={themeSvg} alt="theme" className='menuitemicon' />&nbsp;
              {themeClassObj?.title === 'Blue' ? t('themeNames.Blue') : t('themeNames.Dark')}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
              {themesList.map((row, index) => (
                <li key={index} onClick={() => {
                  setUserTheme(row)
                }}>
                  <h6 className="dropdown-item">
                    {capitalizeFirstLetter(t(`themeNames.${row.title}`))}
                  </h6>
                </li>
              ))}
            </ul>

            <button
              className='btn btn-link dropdown-toggle unset-width'
              type="button"
              title={t('pages.loginContent.select-language')}
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {showLanguageIcon(currentLanguage.country_code)} &nbsp;
              {t(`languageNames.${currentLanguage.country_code}`)}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {languages.map(({ code, name, country_code }) => (
                <li key={country_code}
                  onClick={() => {
                    i18next.changeLanguage(code)
                  }}>
                    <h6 className={currentLanguage.country_code!==code?"dropdown-item":"dropdown-item body-text-extrabold"} >
                      <span className='flexRow alignItemsCenter'>{showLanguageIcon(code)}&nbsp;&nbsp;{t(`languageNames.${code}`)}</span>
                    </h6>
                </li>
              ))}
            </ul>

          </div>

          </div>

          <div className="sign-in-field">
          {signInFields()}
          </div>

          <div style={{display:'flex',justifyContent:'space-between',paddingLeft:"0.35rem",width:'25.0625rem'}}>
                <div className="remember-days" >
                <label style={{display:'flex',alignItems:'center'}}>
      <input type='checkbox' checked={adminLogin} className='checkbox' onChange={()=>setAdminLogin(!adminLogin)}/>
      <span className='small-body-text-regular-login'>
        {t('pages.loginContent.adminLogin')}
      </span>
    </label>
                </div>
                <div
                  className='text-login-forgot-password pointer'
                  onClick={ (e) => handleForgotPassword(e) }
                >
                  {t('pages.loginContent.forgotPassword')}
                </div>
            </div>
            <div  style={{marginLeft:'1%'}} className='flexCol justifyContentFlexStart'>
            {
  passwordResetPrompt !== passwordResetError ? (
    <LoginButton
      disabled={!(username && password) || isLoggingIn}
      onClick={() => onLoginPress("login")}
      isLoading={isLoggingIn}
      buttonText={t('pages.loginContent.signIn')}
      loadingImageSrc={LoadingGIF}
    />
  ) : (
    <LoginButton
      disabled={validatePasswordUpdate || isLoggingIn}
      onClick={() => onLoginPress("update")}
      isLoading={isLoggingIn}
      buttonText={t('pages.loginContent.updatePassword')}
      loadingImageSrc={LoadingGIF}
    />
  )
}
          {(loginMessage.text?.length || loginMessage.error?.length) ? (
            <div className={`flexRow confirmation_popup_login ${loginMessage.error ? 'alert_error' : 'alert_success'}`}>
            <h6 className="subheading-text-medium-title fontLight">
              {loginMessage.text || loginMessage.error}
            </h6>
            </div>
          ) : null}
          </div>


        </div>

      </div>
      {
        !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
    </>
  )
}